export class DialogAction {
    private _display: boolean | (() => boolean) = true;
    private _disabled: boolean | (() => boolean) = false;
    private _loading: boolean | (() => boolean) = false;
    private _title: string | (() => string) = "";
    private _dialogTitle: string | (() => string);
    function?: () => void = undefined;
    previous?: () => void = undefined;

    get title(): string | (() => string) {
        if (typeof this._title === "function") {
            return this._title();
        }
        return this._title;
    }

    set title(value) {
        this._title = value;
    }

    get dialogTitle(): string | (() => string) {
        if (typeof this._dialogTitle === "function") {
            return this._dialogTitle();
        }
        return this._dialogTitle;
    }

    set dialogTitle(value) {
        this._dialogTitle = value;
    }

    get display(): boolean | (() => boolean) {
        if (typeof this._display === "function") {
            return this._display();
        }
        return this._display;
    }

    set display(value) {
        this._display = value;
    }

    get disabled(): boolean | (() => boolean) {
        if (typeof this._disabled === "function") {
            return this._disabled();
        }
        return this._disabled;
    }

    set disabled(value) {
        this._disabled = value;
    }

    get loading(): boolean {
        if (typeof this._loading === "function") {
            return this._loading();
        }
        return this._loading;
    }

    set loading(value: boolean | (() => boolean)) {
        this._loading = value;
    }
}
